"use client";

import { CryptoK } from "@/components/svg/crypto-k";
import { CryptoLine } from "@/components/svg/crypto-line";
import { CryptoEventData, CryptoGuess } from "@/event-core/types";
import { useLocalFirstQuery } from "@/hooks/use-local-first-cache";
import { createLocalFirstQueryOptions, localFirstCacheKeys, localFirstQueryKeys } from "@/lib/query-local-first";
import { useState } from "react";
import { fetchCryptoPrice5sRecent } from "./api";
import CryptoChart from "./crypto-chart";
import LegendSection from "./LegendSection";
import PriceChart from "./price-chart";
import TradeLive from "./trade-live";

function Chart(
    { guess, event, guessList }: { guess: CryptoGuess; event: CryptoEventData; guessList: CryptoGuess[] },
) {
    const [ chartType, setChartType ] = useState<"crypto" | "price">( "crypto" );
    const historyQueryParams = { symbolId: event.symbolId, thirdType: event.thirdType };
    const historyQuery = useLocalFirstQuery( {
        storageKey: event.symbolId ? localFirstCacheKeys.public.cryptoPrice5sRecent( historyQueryParams ) : undefined,
        queryKey: localFirstQueryKeys.cryptoPrice5sRecent( historyQueryParams ),
        queryFn: () => fetchCryptoPrice5sRecent( event.symbolId, event.thirdType ),
        enabled: !!event.symbolId,
        refetchOnMount: "always",
        ...createLocalFirstQueryOptions(),
    } );
    const historyData = historyQuery.data ?? [];
    const historyLatestPrice = historyData.length > 0 ? historyData[historyData.length - 1].value : undefined;

    return (
        <>
            <LegendSection guess={guess} chartType={chartType} historyLatestPrice={historyLatestPrice} />
            <div className="h-[237px] w-full flex-shrink-0 relative">
                {/* 图表切换按钮 */}
                <div className="absolute bottom-[36px] left-[0] flex items-center gap-[4px] rounded-[8px] border border-stroke  p-[4px] shadow-sm z-[11] bg-surface-card">
                    <button
                        type="button"
                        onClick={() => setChartType( "crypto" )}
                        className={`flex h-[28px] w-[28px] items-center justify-center rounded-[6px] transition-colors ${
                            chartType === "crypto"
                                ? "bg-[#F8931A33] text-t1"
                                : "text-t3 hover:bg-surface-muted hover:text-t3"
                        }`}
                    >
                        <CryptoK className="h-[16px] w-[16px] text-[#F8931A]" />
                    </button>
                    <button
                        type="button"
                        onClick={() => setChartType( "price" )}
                        className={`flex h-[28px] w-[28px] items-center justify-center rounded-[6px] transition-colors ${
                            chartType === "price"
                                ? "bg-data-primary-subtle text-t1"
                                : "text-t3 hover:bg-surface-muted hover:text-t3"
                        }`}
                    >
                        <CryptoLine className="h-[16px] w-[16px] text-data-primary" />
                    </button>
                </div>

                {/* 根据 chartType 显示对应的图表 */}
                {chartType === "crypto" && (
                    <CryptoChart guess={guess} symbol={event.symbolId} expo={event.expo} historyData={historyData} />
                )}
                {chartType === "price" && (
                    <PriceChart eventNo={event.eventNo} guessNo={guess.guessNo} guessList={guessList} />
                )}
                <TradeLive className="absolute left-0 bottom-0 z-[12] size-full pointer-events-none"></TradeLive>
            </div>
        </>
    );
}

export default Chart;
